import styled, {css} from 'styled-components';

import {Td as BaseTd} from '@edna/components';
import {ArrowIcon as BaseArrowIcon} from '@edna/components/Collapse/style';
import {Label} from '@edna/components/FormField';
import {Tr as BaseTr} from '@edna/components/Table';
import {Icon} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';
import {TSpacingSize} from '@edna/components/types';
import BaseMoreHorizIcon from '@edna/icons/moreHoriz.svg';

import {Text as BaseText} from 'src/components/primitives';

export const Td = styled(BaseTd)<{isSmallText?: boolean}>`
  ${({isSmallText}) => isSmallText && mixins.f2};
  &:last-child {
    ${mixins.stack({direction: 'ROW'})};
    flex-wrap: wrap;
  }
`;

export const Type = styled.div`
  ${mixins.stack({direction: 'ROW', align: 'center', size: '2'})};
`;

export const Tr = styled(BaseTr)<{borderless?: boolean; isColumn?: boolean}>`
  ${({borderless}) =>
    borderless &&
    css`
      border-bottom: none;
    `}

  ${({isColumn}) =>
    isColumn &&
    css`
      flex-direction: column;
    `}

  &:last-child {
    border-bottom: none;
  }
`;

export const CollapseContent = styled.div`
  ${({theme}) => css`
    margin-left: ${theme.spacing.s4};
  `}
`;

export const Text = styled.div`
  color: ${({theme}) => theme.branding.content.secondary};
`;

export const ArrowIcon = styled(BaseArrowIcon)`
  ${mixins.wh('16px')}

  ${({theme}) => css`
    margin-left: ${theme.spacing.s1};
  `}
`;

export const MoreHorizIcon = styled(BaseMoreHorizIcon)`
  transform: rotate(90deg);
`;

export const SmallLabel = styled(Label)`
  ${mixins.f2};
`;

export const LeftIcon = styled(Icon)<{indent?: TSpacingSize}>`
  margin-right: ${({theme, indent = '1'}) => theme.spacing[`s${indent}`]};
`;

export const Detail = styled(BaseText)`
  ${mixins.stack({direction: 'ROW', size: '2', align: 'center'})}
  flex-wrap: wrap;
`;

export const DetailLabel = styled.span`
  ${mixins.f3}
  color: ${({theme}) => theme.branding.content.secondary};
`;
